module.exports = __webpack_public_path__ + "static/media/pic7.366b451b.jpg";